

exports.__esModule = true;

var _uiRouter = require('uiRouter');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/checkout/index');

var _index2 = require('xo-models/src/fi/index');

var _index3 = require('components/xo-models/src/credit/index');

require('xo-tray-height/dist/directive');

require('xo-ui-components/src/popup/directive');

require('xo-page-components/src/aside-header/directive');

require('xo-ui-components/src/accessibility/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend({

    tag: 'xo-wallet',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: true
        },
        promotion: {
            type: 'var',
            required: false
        },

        installment: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var $scope = this;

            $scope.locale = _squid.$locale;

            $scope.doneFn = function (result) {
                if ($scope.checkoutSession.plan.paypal_credit && $scope.installment.showCYCO) {
                    _uiRouter.$state.go('checkout.chooseCreditOffer');
                } else {
                    _uiRouter.$state.go('checkout.review');
                }
            };

            $scope.showDualFi = (0, _squid.$feature)('addBank');

            (0, _squid.$populate)($scope, {
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token),
                cart: _index.$CheckoutCartModel.create($scope.token),
                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
            }).then(function () {
                $scope.isBillingNoPurchase = $scope.cart.isBillingNoPurchase();

                if ((0, _squid.$feature)('giftCard')) {
                    $scope.showGC = Math.random() < 0.01 && !$scope.isBillingNoPurchase ? true : false;

                    if ($scope.showGC) {
                        _logger.$logger.info('wallet_gift_card_redeem_link_shown');
                    } else {
                        _logger.$logger.info('wallet_gift_card_redeem_link_not_shown');
                    }
                }

                // Manage wallet feature can be turned on by country.
                // User will see manage link on wallet page if feature is turned on and has FIs allowed to edit.
                if ((0, _squid.$feature)('enableManageWallet')) {
                    var managebleFIs = _squid.$util.filter($scope.checkoutSession.fundingOptions.instruments, function (funding) {
                        if (funding && !funding.editDisallowedMsg) {
                            return funding;
                        }
                    });

                    $scope.showManageLink = managebleFIs.length > 0;
                }

                var creditDataModel = _index3.$CreditDataModel.instance($scope.token);
                $scope.checkoutSession.message = null;
                $scope.showAddLink = _squid.$locale.country !== 'DE';
                $scope.showPlcc = $scope.checkoutSession.plccOffer && !$scope.cart.isBilling();
                $scope.showBML = function () {
                    return ($scope.checkoutSession.bmlOffer === 1 || $scope.checkoutSession.bmlOffer === 2) && !$scope.isBillingNoPurchase && !$scope.installment.showBanner && !creditDataModel.isRedirectFromCape();
                };

                $scope.bml = function () {
                    _uiRouter.$state.go('.applyPPC');
                };

                $scope.onRedeemGC = function () {
                    throw new _squid.$FallbackError({
                        reason: 'redeem_coupon_feature_not_supported',
                        product: 'ux',
                        entryPoint: 'giftCard'
                    });
                };

                $scope.addPlcc = function () {
                    if ($scope.promotion) {
                        $scope.promotion.type = 'plcc';
                    }
                    _uiRouter.$state.go('checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard');
                };

                $scope.sacEligible = function (fsName) {
                    // Return false for non BML products
                    if (fsName !== 'BILL_ME_LATER') {
                        return false;
                    }

                    if (!$scope.installment.showCYCO && parseFloat($scope.cart.purchase.amounts.total.amount) >= _index.$CreditOptionsModel.sacEligibleAmount[_squid.$locale.country]) {
                        return true;
                    }
                };

                $scope.cardModel = new _index2.$AddCardModel({
                    card: new _index2.$CardModel()
                });

                $scope.creditOffer = function () {
                    _uiRouter.$state.go('checkout.chooseCreditOffer');
                };

                $scope.userSelectedFI = $scope.checkoutSession.getSelectedStickyInstrument() && $scope.checkoutSession.getSelectedStickyInstrument().instrument_id;

                $scope.updateStickyFS = function (stickyFI) {
                    if (stickyFI.instrument_id !== $scope.userSelectedFI) {
                        $scope.checkoutSession.action('setStickyFI', {
                            data: {
                                instrument_id: stickyFI.instrument_id
                            },
                            success: function success(result) {
                                $scope.checkoutSession.message = {
                                    type: 'success',
                                    msgKeys: ['paymentMethod.paymentMethodUpdated']
                                };
                                $scope.doneFn(result);
                            }
                        });
                    } else {
                        _uiRouter.$state.go('checkout.review');
                    }
                };

                $scope.updateFS = function (fundingsource, $index) {

                    if (fundingsource.infoMsg) {
                        $scope.disallowedIndex = $index;
                        return;
                    }

                    $scope.checkoutSession.message = null;

                    if (fundingsource.planId === $scope.checkoutSession.plan.id) {
                        $scope.doneFn();
                        return;
                    }

                    $scope.checkoutSession.fundingOptions.action('select', {

                        data: {
                            planId: fundingsource.planId
                        },
                        success: function success(result) {

                            $scope.checkoutSession.populate(result);

                            if (result) {
                                // Update the installments to support the user selecting a card that does not support installments.
                                $scope.checkoutSession.installments = result.installments;
                            }

                            if (fundingsource.type === 'CREDIT' && $scope.installment.showCYCO) {
                                _uiRouter.$state.go('checkout.chooseCreditOffer');
                            } else {
                                if (!fundingsource.selected) {
                                    $scope.checkoutSession.message = {
                                        type: 'success',
                                        msgKeys: ['paymentMethod.paymentMethodUpdated']
                                    };
                                    if ($scope.checkoutSession.selectedInstallmentData && !$scope.checkoutSession.selectedInstallmentData.preventChange) {
                                        // Resetting selected installment data, if installment change is not explicitly prohibited.
                                        $scope.checkoutSession.selectedInstallmentData = undefined;
                                    }
                                }

                                $scope.doneFn(result);
                            }
                        },
                        contingencies: {
                            NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, result) {
                                if (result && result.resolution) {
                                    var card = result.resolution.data;

                                    if (card.fundingId && card.fi && card.fi.type) {
                                        $scope.cardModel.id = card.fundingId;
                                        $scope.cardModel.card = new _index2.$CardModel({
                                            number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                                            type: card.fi.type.toUpperCase(),
                                            productType: card.fi.productType
                                        });
                                    }
                                }

                                _uiRouter.$state.go('.confirmUpop');
                            }
                        }
                    });
                };
            });
        }
    }
});


_uiRouter.$state;

_squid.$Component;

_squid.$populate;

_squid.$FallbackError;

_squid.$feature;

_squid.$locale;

_squid.$util;

_logger.$logger;

_index.$CheckoutSessionModel;

_index.$CheckoutCartModel;

_index.$CheckoutAppDataModel;

_index.$CreditOptionsModel;

_index2.$AddCardModel;

_index2.$CardModel;

_index3.$CreditDataModel;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-wallet/directive.js
 ** module id = 347
 ** module chunks = 1
 **/